import Label from '../../../../components/label/label';
import Input from '../../../../components/input/input';
import Button from '../../../../components/button/button';
import CustomSelect from '../../../../components/customSelect/customSelect';
import { useState } from 'react';
import { useMobile } from '../../../../utils/mobileContext';
import { useAlert } from '../../../../hooks/useAlert';
import './customer.components.css';
import IconFA from '../../../../components/icon/icon'
import { Link } from 'react-router-dom';
import { useCustomerContext } from '../../../../utils/customerContext';
import { useSettings } from '../../../../hooks/useSettings';
import { useEffect } from 'react';

function CreateCustomer() {
    const [name, setName] = useState('');
    const [prename, setPrename] = useState('');
    const [address, setAddress] = useState('');
    const [postCode, setPostCode] = useState('');
    const [town, setTown] = useState('');
    const [mail, setMail] = useState('');
    const [phone, setPhone] = useState('');
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [selectedTitle, setSelectedTitle] = useState(null);
    const isMobile = useMobile();
    const { showAlert } = useAlert();
    const { saveCustomer } = useCustomerContext();
    const { data, fetchData } = useSettings();

    const statuses = data?.customerStatusList || ['Statusliste konnte nicht geladen werden. Bitte überprüfe die Einstellungen.'];
    const titles = ['Herr', 'Frau', 'Divers', 'Keine Angabe'];

    useEffect(() => {
        fetchData();
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!prename.trim() || !name.trim() || !address.trim() || !postCode.trim() || !town.trim()) {
            showAlert('Bitte fülle die Pflichtfelder aus (Namen und Adressdaten).', 'error');
            return;
        }

        if(postCode.trim().length !== 5) {
            showAlert('Die Postleitzahl muss genau 5 Zeichen lang sein.', 'error');
            return;
        }
        
        const customerData = { title: selectedTitle?.name, prename, name, phone, mail, address, postCode, town, status: selectedStatus?.name };
        saveCustomer(customerData);
    };

    return (
        <div className='createCustomerContainer'>
            <div className='customerHeader'>
                <Link to='/dashboard/customer'><IconFA iconName='arrowLeft' /></Link>
                <h1>Neuen Kunden hinzufügen</h1>
                <Button
                    buttonValue='Speichern'
                    onClick={handleSubmit}
                />
            </div>
            <div className='createCustomerWrapper'>
                <h2>Persönliche Angaben</h2>
                <div className='createFormContainer'>
                    <div className='createInputContainer'>
                        {!isMobile && <Label labelFor="title" labelValue="Anrede:" />}
                        <CustomSelect
                            items={titles.map(t => ({id: t, name: t}))}
                            selected={selectedTitle}
                            setSelected={setSelectedTitle}
                            placeholder="Anrede wählen"
                            search={false}
                        />
                    </div>
                    <div className='createInputContainer'>
                        {!isMobile && <Label labelFor="prename" labelValue="Vorname:" />}
                        <Input
                            placeholder="Vorname (Pflichtfeld)"
                            inputId="prename"
                            inputName="prename"
                            inputType="text"
                            borderColor='black'
                            value={prename}
                            onChange={(e) => setPrename(e.target.value)}
                        />
                    </div>
                    <div className='createInputContainer'>
                        {!isMobile && <Label labelFor="name" labelValue="Nachname:" />}
                        <Input
                            placeholder="Nachname (Pflichtfeld)"
                            inputId="name"
                            inputName="name"
                            inputType="text"
                            borderColor='black'
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                    </div>                    
                    <div className='createInputContainer'>
                        {!isMobile && <Label labelFor="mail" labelValue="E-Mail:" />}
                        <Input
                            placeholder="E-Mail eingeben"
                            inputId="mail"
                            inputName="mail"
                            inputType="email"
                            borderColor='black'
                            value={mail}
                            onChange={(e) => setMail(e.target.value)}
                        />
                    </div>                    
                    <div className='createInputContainer'>
                        {!isMobile && <Label labelFor="phone" labelValue="Telefon:" />}
                        <Input
                            placeholder="Telefon eingeben"
                            inputId="phone"
                            inputName="phone"
                            inputType="number"
                            borderColor='black'
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                        />
                    </div>                    
                    <div className='createInputContainer'>
                        <Label labelFor="status" labelValue="Kundenstatus:" />
                        <CustomSelect
                            items={statuses.map(s => ({id: s, name: s}))}
                            selected={selectedStatus}
                            setSelected={setSelectedStatus}
                            placeholder="Status wählen"
                            search={false}
                        />
                    </div>                   
                </div>
            </div>
            <div className='createCustomerWrapper'>
                <h2>Adressdaten</h2>
                <div className='createFormContainer'>
                    <div className='createInputContainer'>
                        {!isMobile && <Label labelFor="address" labelValue="Straße + Hausnr." />}
                        <Input
                            placeholder="Straße + Hausnr. (Pflichtfeld)"
                            inputId="address"
                            inputName="address"
                            inputType="text"
                            borderColor='black'
                            width='350px'
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                        />
                    </div>
                    <div className='createInputContainer'>
                        {!isMobile && <Label labelFor="postCode" labelValue="PLZ:" />}
                        <Input
                            placeholder="PLZ (Pflichtfeld)"
                            inputId="postCode"
                            inputName="postCode"
                            inputType="text"
                            borderColor='black'
                            value={postCode}
                            onChange={(e) => setPostCode(e.target.value)}
                        />
                    </div>
                    <div className='createInputContainer'>
                        {!isMobile && <Label labelFor="town" labelValue="Stadt:" />}
                        <Input
                            placeholder="Stadt (Pflichtfeld)"
                            inputId="town"
                            inputName="town"
                            inputType="text"
                            borderColor='black'
                            value={town}
                            onChange={(e) => setTown(e.target.value)}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CreateCustomer;